import React, {useState, useEffect, useCallback} from 'react';
import Tabs from './Tabs';
import JobCard from './JobCard';
import RecruitmentService from '@services/recruitment.service';
import LoadingNavigation from '@components/common/Loading/LoadingNavigation';
import styles from './JobHome.module.css';
import JobCulture from './JobCulture';
import JobBenefits from './JobBenefits';
import RecruitmentProcess from './RecruitmentProcess';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
/**
 * Component trang chủ tuyển dụng
 * Hiển thị danh sách vị trí tuyển dụng và các thông tin liên quan
 */
export default function JobHome(props) {
    const router = useRouter();
    const {locale} = router;
    const [activeIndex, setActiveIndex] = useState(0);
    const [recruitments, setRecruitments] = useState([]);
    const [groupedRecruitments, setGroupedRecruitments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const tabs = props.categories
        .sort((a, b) => Number(a.category_id) - Number(b.category_id))
        .map(c => ({
            category_id: c.category_id,
            category_name: c.category_name,
            news: props.newsByCategory[c.category_id] || [],
        }));
    //console.log(props.newsByCategory);
    // Lấy danh sách tuyển dụng từ API
    const fetchRecruitmentsCallback = useCallback(() => {
        if (!locale) return;
        fetchRecruitments();
    }, [locale]);

    useEffect(() => {
        fetchRecruitmentsCallback();
    }, [fetchRecruitmentsCallback]);

    const fetchRecruitments = async () => {
        setIsLoading(true);
        try {
            const recruitmentService = new RecruitmentService();
            const res = await recruitmentService.getRecruitmentList({
                locale,
                pageIndex: 1,
                pageSize: 50,
                keyword: '',
            });

            const items = res.data || [];
            setRecruitments(items);

            const grouped = groupByDepartment(items);
            setGroupedRecruitments(grouped);
        } catch (error) {
            //console.error('Error fetching recruitments:', error);
        } finally {
            setIsLoading(false);
        }
    };

    /**
     * Nhóm các vị trí tuyển dụng theo phòng ban
     * @param {Array} items - Danh sách vị trí tuyển dụng
     * @returns {Array} Danh sách đã được nhóm theo phòng ban
     */
    const groupByDepartment = items => {
        const grouped = {};
        items.forEach(item => {
            const departmentName = item.department_name || 'Khác';
            const departmentId = item.department_id || 'other';
            const key = `${departmentId}_${departmentName}`;

            if (!grouped[key]) {
                grouped[key] = {
                    department_id: departmentId,
                    department_name: departmentName,
                    jobs: [],
                };
            }
            grouped[key].jobs.push(item);
        });

        return Object.keys(grouped).map(key => ({
            category: grouped[key].department_name,
            department_id: grouped[key].department_id,
            jobs: grouped[key].jobs,
        }));
    };

    return (
        <section className={styles.jobSection}>
            <div className={styles.jobTitleArea}>
                <h2 className={styles.jobTitle}>{getLocaleContent(locale, 'page.recruitment.title')}</h2>
                <Tabs
                    items={tabs.map(t => t.category_name)}
                    activeIndex={activeIndex}
                    onChange={setActiveIndex}
                    className={styles.jobTabs}
                />
            </div>

            {activeIndex === 0 && (
                <div className={styles.jobListContainer}>
                    {isLoading ? (
                        <LoadingNavigation size="large" color="#006940" />
                    ) : groupedRecruitments.length === 0 ? (
                        <div className={styles.tabContent}>
                            {getLocaleContent(locale, 'page.recruitment.no_recruitment')}
                        </div>
                    ) : (
                        groupedRecruitments.map((group, index) => (
                            <div className={styles.jobGroup} key={index}>
                                <h3 className={styles.jobCategory}>{group.category}</h3>
                                <div className={styles.jobList}>
                                    {group.jobs.map((job, idx) => (
                                        <div key={job.recruitment_id || idx} className={styles.jobCardWrapper}>
                                            <JobCard job={job} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}

            {activeIndex === 1 && (
                <div className={styles.tabContent}>
                    <JobCulture news={tabs[activeIndex].news} />
                </div>
            )}
            {activeIndex === 2 && (
                <div className={styles.tabContent}>
                    <JobBenefits news={tabs[activeIndex].news} />
                </div>
            )}
            {activeIndex === 3 && (
                <div className={styles.tabContent}>
                    <RecruitmentProcess news={tabs[activeIndex].news} />
                </div>
            )}
        </section>
    );
}
